import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UiFeedbackService } from '../services/ui-feedback.service';

export const showLayoutGuard: CanActivateFn = (route, state) => {
  const uiFeedback = inject(UiFeedbackService);

  uiFeedback.setShowPrincipalLayout(true);
  return true;
};
